<template>
  <div class="page page--home companies">
    <div class="companies__header">
      <search-input
        v-model:value="searchCompanyName"
        class="companies__search-input"
        :title="$t('companies.search-title')"
      ></search-input>
      <primary-button
        class="companies__add-btn"
        :label="$t('companies.add-button')"
        :disabled="false"
        @click="addCompany"
      ></primary-button>
    </div>
    <div class="companies__list">
      <template v-if="companiesLoaded">
        <company-card
          class="company-card"
          v-for="company in filteredCompanies"
          :key="`company-${company.ID}`"
          :company="company"
        ></company-card>
      </template>
      <template v-else>
        <div class="companies__loader">
          <loader></loader>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CompanyCard from '@vue-app/components/company/card/CompanyCard.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import SearchInput from '@vue-app/components/base/input/SearchInput.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import ShareBillLinkPopup from '@vue-app/components/company/bills/popup/ShareBillLinkPopup.vue'
import { Bill } from '@js-app/entities/Bill'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Home',
  components: {
    ShareBillLinkPopup,
    Loader,
    PrimaryButton,
    SearchInput,
    CompanyCard,
  },
  data() {
    return {
      searchCompanyName: '',
      bill: new Bill({}),
    }
  },
  created() {
		if (!this.companiesLoaded) {
			this.$store.dispatch('LOAD_COMPANIES')
		}
  },
  methods: {
    async loadCompanies() {
      this.isCompaniesLoaded = false
      const companiesResponse = await CompaniesApi.getCompanies()
      this.companies = companiesResponse.data
      this.isCompaniesLoaded = true
    },

    addCompany() {
      const url = `${window.location.origin}/getting-started/select-account-type`
      window.location.href = url
    },
  },

  computed: {
		...mapState(['companies', 'companiesLoaded']),

    filteredCompanies() {
      if (this.searchCompanyName.trim().length === 0) {
        return this.companies
      }

      return this.companies.filter((_c) =>
        _c.CompanyName.toLowerCase().includes(
          this.searchCompanyName.toLowerCase()
        )
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--home {
    margin-top: 60px;
  }
}
.companies {
  &__header {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  &__list {
    column-gap: 17px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
  }

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 30px;
  }

  &__search-input {
    max-width: 190px;
    margin-right: 15px;
  }

  &__add-btn {
    padding: 13px 32px;
  }
}
.company-card {
  margin-bottom: 30px;
}
@media screen and (max-width: 992px) {
  .page {
    &--home {
      margin-top: 20px;
    }
  }
  .company-card {
    margin-bottom: 20px;
  }
}
</style>
